import { Controller } from '@hotwired/stimulus'
import { isInViewport } from '../modules/utils'

export default class extends Controller {
  static targets = ['tab']
  static classes = ['active', 'inactive']

  declare readonly activeClasses: string[]
  declare readonly inactiveClasses: string[]
  declare readonly tabTargets: [HTMLElement, ...HTMLElement[]]
  declare activeTab: HTMLElement

  connect (): void {
    this.reset()
  }

  touch (e: Event): void {
    this.activate(this.tabTargets.find(tab => tab.contains(e.target as HTMLElement)) as HTMLElement)
  }

  activate (tab: HTMLElement): void {
    if (this.activeTab !== null && this.activeTab !== undefined) {
      this.activeTab.classList.remove(...this.activeClasses)
      this.activeTab.classList.add(...this.inactiveClasses)
    }
    this.activeTab = tab
    if (this.activeTab !== null && this.activeTab !== undefined) {
      this.activeTab.classList.add(...this.activeClasses)
      this.activeTab.classList.remove(...this.inactiveClasses)
      if (!isInViewport(this.activeTab)) this.activeTab.scrollIntoView({ behavior: 'smooth' })
    }
  }

  reset (): void {
    const tab = this.tabTargets.find(this.active_tab_condition.bind(this)) ?? this.tabTargets[0]

    this.activate(tab)
  }

  private active_tab_condition (tab: HTMLElement): boolean {
    const locationHref = location.pathname + location.search + location.hash
    const regexp = (this.element as HTMLElement).dataset.activeTabHrefRegexp

    if (regexp == null || regexp === undefined) {
      return tab.querySelector(`a[href="${locationHref}"]`) !== null
    }

    const tabHref = tab.querySelector('a')?.getAttribute('href')

    if (tabHref == null || tabHref === undefined) return false

    const regexpObj = new RegExp(regexp)
    const locationMatch = locationHref.match(regexpObj)
    const tabMatch = tabHref.match(regexpObj)

    if (locationMatch == null || tabMatch == null) return false

    return locationMatch[0] === tabMatch[0]
  }
}
